export const API_BASEURL = "https://energymeter-api.verycautious.de"